export enum USERROLE {
    NULL = 'NULL',
  
  
    HO = 'HO',
    PA = 'PA',
    DBD = 'DBD',
    SUPER = 'SUPER',
    AML = 'AML',
  }

  export interface IKeyValue {
  key: string;
  value: string;
  selected?: boolean;
}

  export class TodoItemNode {
    children!: TodoItemNode[];
    label!: string;
    id!: string;
    isChecked!: boolean;
  }

  export class AdvisorHirerarchy {
    regions!: AdvisorRegion[];
  }
  export class AdvisorRegion {
    regName!: string;
    hubs!: AdvisorHub[];
    isInc: boolean;
    constructor() {
      this.isInc = true;
    }
  }
  export class AdvisorHub {
    hubName!: string;
    teams!: AdvisorTeam[];
    isInc: boolean;
    constructor() {
      this.isInc = true;
    }
  }
  export class AdvisorTeam {
    teamName!: string;
    advisors!: AdvNameId[];
    isInc: boolean;
    constructor() {
      this.isInc = true;
    }
  }
  
  export class AdvNameId {
    repId!: string;
    repName!: string;
    isInc: boolean;
    constructor() {
      this.isInc = true;
    }
  }

  export enum WorkflowStatus {
  DRAFT = 'DRAFT',
  DBDREVIEW = 'DBDREVIEW',
   AMLREVIEW = 'AMLREVIEW',
 
  
  SUBMITTED = 'SUBMITTED', // Attested by PW
  RETURNEDBM = 'RETURNED-BM', // Returned by DBD
  RETURNEDAML = 'RETURNED-AML', // Returned by DBD
  RESUBMITTED = 'RESUBMITTED', // Re-submitted by Advisor
  CLOSED = 'CLOSED', // Accounts that are reviewed and closed
 
}